<template>
  <v-dialog v-model="dialog" persistent width="700">
    <template v-slot:activator="{ on }">
      <v-tooltip v-if="Boolean(plan)" bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            @click="openDialog"
            small
            color="primary"
            class="ma-4"
            >mdi-dots-vertical</v-icon
          >
        </template>
        <span v-if="!viewOnly">Edit Plan Details</span
        ><span v-else>View Plan Details</span>
      </v-tooltip>
      <v-btn
        v-else
        v-on="on"
        @click="openDialog"
        small
        color="primary"
        rounded
        outlined
        class="ma-4"
      >
        <v-icon small>mdi-plus</v-icon> New Plan
      </v-btn>
    </template>
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-card>
        <v-card-title color="primary">
          Plan
          <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> </v-card-title
        ><v-card-text>
          <v-text-field
            :label="`${client.firstName} ${client.lastName} - ${client.formattedOsis}`"
            disabled
            readonly
          >
          </v-text-field>
          <v-row>
            <v-col cols="12" sm="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-autocomplete
                  v-model="form.planTypeId"
                  label="Plan Type"
                  :items="groupedPlanTypes"
                  item-text="description"
                  item-value="planTypeId"
                  :hint="
                    Boolean(form.planTypeId) ? `(${planTypeAgeCategory})` : ''
                  "
                  persistent-hint
                  :error-messages="errors"
                  :clearable="!viewOnly"
                  :readonly="viewOnly"
                ></v-autocomplete> </validation-provider
            ></v-col>
            <v-col cols="12" sm="4">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-autocomplete
                  v-model="form.languageId"
                  label="Language"
                  :items="languages"
                  item-text="name"
                  item-value="languageId"
                  :error-messages="errors"
                  :clearable="!viewOnly"
                  :readonly="viewOnly"
                ></v-autocomplete></validation-provider
            ></v-col>
            <v-col cols="12" sm="4">
              <validation-provider
                v-if="
                  planTypeAgeCategory == 'Preschool' ||
                  planTypeAgeCategory == 'SchoolAge'
                "
                :rules="{ required: !form.isIncomplete }"
                v-slot="{ errors }"
              >
                <v-radio-group
                  v-model="form.isSummerSemesterIncluded"
                  label="10/12 Month"
                  :disabled="viewOnly"
                  row
                  class="mx-1 mt-1"
                  :error-messages="errors"
                >
                  <v-radio label="10 Month" :value="false"></v-radio>
                  <v-radio label="12 Month" :value="true"></v-radio>
                </v-radio-group> </validation-provider></v-col
          ></v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'IEP Meeting Date' }"
                  :value="form.planMeetingDate"
                  @fieldChange="form.planMeetingDate = $event"
                  :validations="{ required: !form.isIncomplete }"
                  :readonly="viewOnly"
                >
                </date-picker></div
            ></v-col>
            <v-col cols="12" sm="4">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'IEP Plan Date' }"
                  :value="form.planStartDate"
                  :validations="{ required: true }"
                  @fieldChange="form.planStartDate = $event"
                  :readonly="viewOnly"
                >
                </date-picker></div></v-col
            ><v-col cols="12" sm="4">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'Plan Closure Date' }"
                  :value="form.closureDate"
                  :validations="{ minDate: form.planStartDate }"
                  @fieldChange="form.closureDate = $event"
                  :readonly="viewOnly || isNewPlan"
                >
                </date-picker></div></v-col
          ></v-row>
        </v-card-text>
        <v-card-actions v-if="!viewOnly">
          <v-spacer></v-spacer>
          <v-btn small color="primary" text @click="closeDialog">Cancel</v-btn>
          <v-btn
            small
            color="primary"
            :disabled="invalid || loading"
            @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import Plan from "../../../objs/Plan";
export default {
  props: ["plan", "viewOnly"],
  data() {
    return {
      form: new Plan(),
      dialog: false,
      loading: false,
    };
  },
  computed: {
    isNewPlan() {
      return !Boolean(this.plan);
    },
    planTypes() {
      return this.$store.state.optionsModule.planTypes;
    },
    groupedPlanTypes: function () {
      // organize plan type dropdown - group them by age category
      return this.planTypes.reduce((group, planType) => {
        let match = group.find(
          (item) => item.ageCategory === planType.ageCategory
        );
        if (!match) {
          group.push({ header: planType.ageCategory });
        }
        if (planType.description == "Unknown") {
          planType.disabled = true;
        }
        group.push(planType);
        return group;
      }, []);
    },
    planTypeAgeCategory() {
      return Boolean(this.form.planTypeId)
        ? this.planTypes.find((x) => x.planTypeId == this.form.planTypeId)
            .ageCategory
        : "";
    },
    languages() {
      return this.$store.state.optionsModule.languages || [];
    },
    client() {
      return this.$store.state.clientModule.selectedClient;
    },
  },
  methods: {
    openDialog() {
      if (!this.isNewPlan) {
        this.form = { ...this.plan };
        this.form.planStartDate = this.form.planStartDate
          ? new Date(this.plan.planStartDate)
          : null;
        this.form.planMeetingDate = this.form.planMeetingDate
          ? new Date(this.plan.planMeetingDate)
          : null;
        this.form.closureDate = this.form.closureDate
          ? new Date(this.plan.closureDate)
          : null;
      }
      this.form.clientId = this.client.clientId;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async save() {
      this.loading = true;
      let message;
      if (this.isNewPlan) {
        // create
        message = await this.$store.dispatch(
          "plansModule/createPlan",
          this.form
        );
      } else {
        // update
        message = await this.$store.dispatch(
          "plansModule/updatePlan",
          this.form
        );
      }
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Plan saved successfully"
        );
      }
      this.loading = false;
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.closeDialog();
    },
  },
};
</script>
